import { requestWrapper } from 'e-submission/domain/data'

export const reValidateAge = (user, appId) => {
  return requestWrapper
    .getRequest(`re-validate-age/check-changed-age/applicationId/${appId}`, user)
    .then(({ data }) => data)
}

export const checkPremiumCal = (user, appId) => {
  return requestWrapper
    .getRequest(`re-validate-age/check-changing-premium-cal/applicationId/${appId}`, user)
    .then(({ data }) => data)
}

export const regenerateBi = (user, appId, totalPremium) => {
  return requestWrapper
    .getRequest(`re-validate-age/regenerate-bi/applicationId/${appId}/totalPremium/${totalPremium}`, user)
    .then(({ data }) => data)
}

export const updateReValidateAgePolicy = (user, policyId, payload) => {
  return requestWrapper.patchRequest(`re-validate-age/policyId/${policyId}`, user, payload).then(({ data }) => data)
}

export const rollbackStatus = (user, policyID, payload) => {
  return requestWrapper
    .patchRequest(`re-validate-age/rollbackStatus/policyId/${policyID}`, user, payload)
    .then(({ data }) => data)
}
